import { Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { LayoutStrutureSite } from "../layout";
import Home from "../pages";
import NotFound from "../pages/NotFound";
import Register from "../pages/Register";
import Pagementos from "../pages/Pagementos";
import UserLogin from "../pages/Register/UserLogin";
import UserRegister from "../pages/Register/UserRegister";
import Contact from "../pages/Contact";
import Instituicoes from "../pages/Instituicoes";

export default function PagesRouter() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <Routes>
        <Route path="/" element={<LayoutStrutureSite><Home /></LayoutStrutureSite>} />
        <Route path="/payment" element={<LayoutStrutureSite><Pagementos /></LayoutStrutureSite>} />
        <Route path="/register" element={<LayoutStrutureSite><Register /></LayoutStrutureSite>} />
        <Route path="/access-user" element={<LayoutStrutureSite><UserLogin /></LayoutStrutureSite>} />
        <Route path="/register-user/:id" element={<LayoutStrutureSite><UserRegister /></LayoutStrutureSite>} />
        <Route path="/contact" element={<LayoutStrutureSite><Contact /></LayoutStrutureSite>} />
        <Route path="/instituicoes" element={<LayoutStrutureSite><Instituicoes /></LayoutStrutureSite>} />

        {/* Redireccionamentos de rotas antigas */}
        <Route path="/sigup/*" element={<Navigate to="/register" replace />} />
        <Route path="/signin" element={<Navigate to="/access-user" replace />} />
        <Route path="/sorry" element={<Navigate to="/" replace />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
}
